/**
 * Fiskal Cloud Notification API
 * # Changelog ## 1.0.0 * Notification API 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { NotificationDTO } from '../model/models';
import { NotificationsResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ConfirmNotificationRequestParams {
    notificationId: string;
}

export class ClsConfirmNotificationRequestParams {
    notificationId: string = undefined;
}

export interface GetNotificationRequestParams {
    notificationId: string;
}

export class ClsGetNotificationRequestParams {
    notificationId: string = undefined;
}

export interface ListNotificationsRequestParams {
    read?: boolean;
    organizationId?: string;
    businessPremisesId?: string;
    notificationDateFrom?: string;
    notificationDateTo?: string;
    pageNumber?: number;
    pageSize?: number;
    sort?: string;
}

export class ClsListNotificationsRequestParams {
    read?: boolean = undefined;
    organizationId?: string = undefined;
    businessPremisesId?: string = undefined;
    notificationDateFrom?: string = undefined;
    notificationDateTo?: string = undefined;
    pageNumber?: number = undefined;
    pageSize?: number = undefined;
    sort?: string = undefined;
}


export interface NotificationsApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Confirm the notification
     * Confirm the notification
* @param requestParameters
     */
    confirmNotification(requestParameters: ConfirmNotificationRequestParams, extraHttpRequestParams?: any): Observable<NotificationDTO>;

    /**
     * Receive detail of the notification
     * Receives detail of the notification
* @param requestParameters
     */
    getNotification(requestParameters: GetNotificationRequestParams, extraHttpRequestParams?: any): Observable<NotificationDTO>;

    /**
     * Receive list of notifications
     * Receives list of notifications with possible filtering options
* @param requestParameters
     */
    listNotifications(requestParameters: ListNotificationsRequestParams, extraHttpRequestParams?: any): Observable<NotificationsResponseDTO>;

}
